@if (initialized) {
    <div class="cn-import-review-container surface-0">

        <!-- Eingangsfreigabe body (P3): Gesellschaft selection, the list of import DRAFTS for the
             chosen Gesellschaft with select-all, and the bulk approve/reject actions. The whole
             orchestration lives in the hosted CnImportReviewComponent and its data layer
             (CnImportApiService). The page shell owns the routed skeleton + header only. -->
        <mvs-cn-import-review></mvs-cn-import-review>

    </div>
}
